import { useRef } from "react";
import useOnScreen from "../hooks/useOnScreen";

export const BenefitsWrapper = ({children, dark = false, padding = "var(--landing-page-padding)"}) => {
    return <>
        <div className={"benefits " + (dark && "dark")}>
            <div className="benefits__content">
                {children}
            </div>
        </div>
        <style jsx>
            {`
            .benefits {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 100vw;
                // min-height: 20vh;
                height: max-content;
                background: var(--off-white);
            }
            .benefits.dark {
                background-color: var(--covalent-dark-blue);
                color: #fff;
            }
            :global(.benefits.dark .benefits__cards) {
                margin-top: 2rem;
                margin-bottom: 2rem;
                padding: 0;
            }
            :global(.benefits.dark .benefits__cards) {
                flex-wrap: wrap;
                width: 100%;
            }
            :global(.benefits.dark .benefits__card) {
                display: flex;
                flex-direction: column;
                justify-content: start;
                align-items: start;
                flex: 1 1 calc(25% - 1.5rem);
                min-width: 200px;
                height: 100%;
                padding: 2rem;
                border-radius: calc(var(--border-radius) * 2);
                background-color: black;
                transform: translate(0);
                transform-style: preserve-3d;
                height: auto;
                z-index: 1;
                position: relative;
                border: 1px solid var(--black-light);
                // opacity: 0.85;
                transition: all 0.2s ease-in-out;
            }

            :global(.benefits.dark .benefits__card:hover) {
                border: 1px solid var(--pink);
                transition: all 0.2s ease-in-out;
            }

            @keyframes backgroundGradient {
                0% {
                    background-position: 0% 50%;
                    transform: scale(1.01);
                }
                100% {
                    background-position: 100% 50%;
                    transform: scale(0.98);
                }
            }

            :global(.benefits.dark .benefits__card::before) {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-image: linear-gradient(45deg, #ff4c8b80, var(--teal));
                z-index: -1;
                filter: blur(5px);
                border-radius: calc(var(--border-radius) * 2);
                animation: backgroundGradient 4s ease-in-out infinite alternate;
                background-size: 200% 200%;
                // opacity: 0.85;
                transition: all 0.2s ease-in-out;
            }

            :global(.benefits.dark .benefits__card:hover::before) {
                filter: blur(25px);
                transition: all 0.2s ease-in-out;
                background-image: linear-gradient(45deg, var(--pink), var(--teal));
            }

            :global(.benefits.dark .benefits__card::after) {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: var(--covalent-dark-blue);
                z-index: -1;
                border-radius: calc(var(--border-radius) * 2);
                // opacity: 0.85;
            }
            :global(.benefits.dark .benefits__description) {
                color: var(--gray-medium);
            }
            :global(.benefits.dark .benefits__card:hover::after) {
                background-image: linear-gradient(135deg,#00d8d521 0%,#ff4c8b33 100%);
            }
            .benefits__content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                height: max-content;
                padding: ${padding};
                max-width: var(--landing-page-max-width);
                margin: 0 auto;
                width: 100%;
            }
            @media (max-width: 768px) {
                .benefits {
                    flex-direction: column;
                    height: auto;
                }
                .benefits__content {
                    width: 100%;
                    height: auto;
                    padding: var(--landing-page-padding);
                }
            }
        `}
        </style>
    </>;
};

export const BenefitsTitle = ({children}) => {
    const animatedRef = useRef<HTMLDivElement>(null);
    const isOnScreen = useOnScreen(animatedRef);

    return <><h2 ref={animatedRef} className={(isOnScreen ? "benefits__title__on__screen" : "")}>
        {children}
    </h2>
    <style jsx>
        {`
            h2 {
                font-size: var(--font-size-7);
                margin-bottom: 1rem;
                line-height: 1.2;
                opacity: 0;
            }
            .benefits__title__on__screen {
                animation: fadeIn 0.5s ease-in-out forwards;
            }
        `}
    </style>
    </>;
};

export const BenefitsSubtitle = ({children}) => {
    return <>
        <p>
            {children}
        </p>
        <style jsx>
            {`
            p {
                font-size: var(--font-size-5);
                margin-bottom: 1rem;
            }
        `}
        </style>
    </>;
};

export const BenefitsCtas = ({children}) => {
    return <><div className="benefits__cta">
        {children}
    </div>
    <style jsx>
        {`
            .benefits__cta {
                gap: 1rem;
                display: flex;
                margin-top: var(--landing-page-gap);
            }
        `}
    </style>
    </>;
};

export const BenefitsCta = ({children}) => {
    return <div className="benefits__cta">
        {children}
    </div>;
};

export const BenefitsCard = ({children}) => {

    const animatedRef = useRef<HTMLDivElement>(null);
    const isOnScreen = useOnScreen(animatedRef);

    return <><div ref={animatedRef} className={"gradient-border benefits__card " + (isOnScreen && "benefits__card__on__screen")}>
        {children}
    </div>
    <style jsx>
        {`
            div {
                display: flex;
                flex-direction: column;
                justify-content: start;
                align-items: start;
                width: 100%;
                gap: 1rem;
                border: 1px solid var(--code-border);
                padding: var(--landing-page-gap);
                border-radius: calc(var(--border-radius) * 1);
                height: auto;
                position: relative;
                background: #fff;
                cursor: default;
                opacity: 0;
            }

            .benefits__card__on__screen {
                animation: fadeIn 0.5s ease-in-out forwards;
            }

            :global(.benefits__cards .benefits__card__on__screen:nth-child(2)) {
                animation-delay: 0.25s;
            }
            :global(.benefits__cards .benefits__card__on__screen:nth-child(3)) {
                animation-delay: 0.5s;
            }
            :global(.benefits__cards .benefits__card__on__screen:nth-child(4)) {
                animation-delay: 0.75s;
            }
            :global(.benefits__cards .benefits__card__on__screen:nth-child(5)) {
                animation-delay: 1s;
            }
            :global(.benefits__cards .benefits__card__on__screen:nth-child(6)) {
                animation-delay: 1.25s;
            }
            :global(.benefits__cards .benefits__card__on__screen:nth-child(7)) {
                animation-delay: 1.5s;
            }
            :global(.benefits__cards .benefits__card__on__screen:nth-child(8)) {
                animation-delay: 1.75s;
            }

            @media (max-width: 768px) {
                div {
                    flex-direction: column;
                    place-items: start;
                }
            }
        `}
    </style></>;
};


export const BenefitsCards = ({children}) => {
    return <><div className="benefits__cards">
        {children}
    </div>
    <style jsx>
        {`
            div {
                display: flex;  
                flex-direction: row;
                justify-content: start;
                gap: var(--landing-page-gap);
            }
            @media (max-width: 768px) {
                div {
                    flex-direction: column;
                    place-items: start;
                }
            }
        `}
    </style></>;
};

export const BenefitsCardCTA = ({children}) => {
    return <><div>
        {children}
    </div>
    <style jsx>
        {`
            div {
                margin-top: auto;
            }
        `}
    </style></>;
};

export const BenefitsCardTitle = ({children}) => {
    return <><h2>
        {children}
    </h2>
    <style jsx>
        {`
            div {
                font-size: var(--font-size-6);
                color: var(--pink);
            }
            h2 {
                font-size: var(--font-size-6);
                margin-bottom: 1rem;
                margin-top: 0;
                margin: 0;
                line-height: 1.2;
            }
        `}
    </style></>;
};

export const BenefitsCardDescription = ({children}) => {
    return <><p className="benefits__description">
        {children}
    </p>
    <style jsx>
        {`
            p {
                color: var(--black-light);
            }
        `}
    </style></>;
};

export const BenefitsCardIcon = ({src}) => {
    return <><div>
        <img height={50} width={50} src={src} alt={src}/>
    </div>
    <style jsx>
        {`
           
        `}
    </style></>;
};

export const BenefitsCardImage = ({src, width = "100%", height = "auto", maxWidth = "8rem"}) => {
    return <><div className="image">
        <img src={src} alt={src}/>
    </div>
    <style jsx>
        {`
           .image {
                max-width: ${maxWidth};
                width: ${width};
                height: ${height};
           }
        `}
    </style></>;
};

export const BenefitsBadge = ({children}) => {
    return <><div>
        {children}
    </div>
    <style jsx>
        {`
            div {
                font-size: var(--font-size-5);
                margin-bottom: 1rem;
                color: var(--pink);
            }
        `}
    </style></>;
};